// extracted by mini-css-extract-plugin
var _1 = "DetailsStyles-module__col-6___a_TYi";
var _2 = "DetailsStyles-module__col-6___a_TYi";
var _3 = "DetailsStyles-module__details____rc7O";
var _4 = "DetailsStyles-module__detailsEdit___MbNEu";
var _5 = "DetailsStyles-module__detailsSelect___R4hui";
var _6 = "DetailsStyles-module__holder___riGWm";
var _7 = "DetailsStyles-module__info___yck_h";
var _8 = "DetailsStyles-module__info_location___N57P1";
var _9 = "DetailsStyles-module__info_website___cqW10";
var _a = "DetailsStyles-module__info_year___Tsod1";
var _b = "DetailsStyles-module__info_location___N57P1";
var _c = "DetailsStyles-module__info_website___cqW10";
var _d = "DetailsStyles-module__info_year___Tsod1";
var _e = "DetailsStyles-module__legal-name___S5SPn";
var _f = "DetailsStyles-module__legal-name___S5SPn";
var _10 = "DetailsStyles-module__questions____VZ5i";
var _11 = "DetailsStyles-module__text___RjJBV";
var _12 = "DetailsStyles-module__website___wYxF0";
export { _1 as "col-6", _2 as "col6", _3 as "details", _4 as "detailsEdit", _5 as "detailsSelect", _6 as "holder", _7 as "info", _8 as "infoLocation", _9 as "infoWebsite", _a as "infoYear", _b as "info_location", _c as "info_website", _d as "info_year", _e as "legal-name", _f as "legalName", _10 as "questions", _11 as "text", _12 as "website" }
